import React from "react";
import { motion } from "framer-motion";

export const SectionHeading = ({ overline, title, description, align = "left", testId, children }) => {
    const alignClass = align === "center" ? "text-center items-center" : "text-left items-start";
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className={`flex flex-col ${alignClass} gap-4 mb-14`}
            data-testid={testId}
        >
            {overline && <span className="overline">{overline}</span>}
            <h2 className="font-serif text-4xl md:text-5xl text-white leading-[1.05] max-w-3xl">{title}</h2>
            {description && (
                <p className="text-base md:text-lg text-slate-400 font-light leading-relaxed max-w-2xl">
                    {description}
                </p>
            )}
            {children}
        </motion.div>
    );
};

export const Overline = ({ children, className = "" }) => (
    <span className={`overline ${className}`}>{children}</span>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export default SectionHeading;
